// @flow
import { openItemActionPanel } from "components/ItemActionPanel";
import { getLocalizedText } from "data/utils";

export const openMultiSelectionActionPanel = ({
    targetView,
    activeRows,
    mapper,
    folderItemUri,
    ...contextProps
}: {
    targetView: string,
    activeRows: any,
    mapper: (row: any) => any,
}) => {
    let docCount = 0;
    let folderCount = 0;
    const items = Object.values(activeRows).map(mapper);
    items.forEach((row) => {
        row.isDoc ? docCount++ : folderCount++;
    });
    const itemKey =
        docCount && folderCount ? "mixed" : docCount ? "document" : "folder";
    return openItemActionPanel({
        title: getLocalizedText(`$multiselection:actionpanel.${itemKey}`, {
            document: getLocalizedText(`$multiselection:actionpanel.document`, {
                count: docCount,
            }),
            folder: getLocalizedText(`$multiselection:actionpanel.folder`, {
                count: folderCount,
            }),
            count: docCount + folderCount,
        }),
        contextProps: {
            ...contextProps,
            items,
            multiple: true,
            folderItemUri,
        },
        targetView,
    });
};
